// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"712":"4a37dd4a","969":"e885c045"}[chunkId] + ".chunk.js";
};